import React from 'react';

const Questions = () => {
    return (
        <div className="drop-down-questions-wrapper">
            <h2 className="question-title xmb-10 xmb-lg-16 text-center">سوالات متداول</h2>
            <div className="container question-container">
                <div className="question-drop-down">
                    <div className="accordion-item">
                        <div className="accordion-header accordion-button collapsed" id="vendor-question-drop-one"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-one" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-one">
                            <span className="title-toggle">
                            چه کسانی می‌توانند در مرکز فروشندگان سایمان، فروشنده باشند؟
                            </span>
                        </div>
                        <div id="panels-stay-open-collapse-one" className="accordion-collapse collapse"
                             aria-labelledby="vendor-question-drop-one">
                            <div className="accordion-body">
                                <p className="text">این برند چینی از زمان ورود به ایران با استقبال و بازخورد مثبت
                                    کاربران ایرانی مواجه شده‌ است. در حال حاضر انواع شارژر و پاوربانک، کابل و پایه‌های
                                    نگهدارنده این شرکت در ایران به فروش می‌رسد. </p>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item xmt-4">
                        <div className="accordion-header accordion-button collapsed" id="vendor-question-drop-two"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-two" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-two">
                            <span className="title-toggle">
                           چه مدارکی جهت ثبت‌نام در مرکز فروشندگان سایمان مورد نیاز است؟
                            </span>
                        </div>
                        <div id="panels-stay-open-collapse-two" className="accordion-collapse collapse"
                             aria-labelledby="vendor-question-drop-two">
                            <div className="accordion-body">
                                <p className="text">این برند چینی از زمان ورود به ایران با استقبال و بازخورد مثبت
                                    کاربران ایرانی مواجه شده‌ است. در حال حاضر انواع شارژر و پاوربانک، کابل و پایه‌های
                                    نگهدارنده این شرکت در ایران به فروش می‌رسد. </p>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item xmt-4">
                        <div className="accordion-header accordion-button collapsed" id="vendor-question-drop-three"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-three" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-three">
                            <span className="title-toggle">
                           خدمات سایمان برای فروشندگان چیست؟
                            </span>
                        </div>
                        <div id="panels-stay-open-collapse-three" className="accordion-collapse collapse"
                             aria-labelledby="vendor-question-drop-three">
                            <div className="accordion-body">
                                <p className="text">این برند چینی از زمان ورود به ایران با استقبال و بازخورد مثبت
                                    کاربران ایرانی مواجه شده‌ است. در حال حاضر انواع شارژر و پاوربانک، کابل و پایه‌های
                                    نگهدارنده این شرکت در ایران به فروش می‌رسد. </p>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item xmt-4">
                        <div className="accordion-header accordion-button collapsed" id="vendor-question-drop-four"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-four" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-four">
                            <span className="title-toggle">
                          قوانین و مقررات فروش در سایت سایمان چیست؟
                            </span>
                        </div>
                        <div id="panels-stay-open-collapse-four" className="accordion-collapse collapse"
                             aria-labelledby="vendor-question-drop-four">
                            <div className="accordion-body">
                                <p className="text">این برند چینی از زمان ورود به ایران با استقبال و بازخورد مثبت
                                    کاربران ایرانی مواجه شده‌ است. در حال حاضر انواع شارژر و پاوربانک، کابل و پایه‌های
                                    نگهدارنده این شرکت در ایران به فروش می‌رسد. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Questions;
